import { z } from "zod";
import {
  MOBILITY_TYPE_SCHEMA,
  PLATFORM_STATUS_SCHEMA,
  PLATFORM_TYPE_SCHEMA,
} from "./constants";
import { positionSchema } from "../shared/position";
import { siloSchema, silosSchema } from "./siloSchema";

export const platformSchema = z.object({
  /**
   * Optional because DB usually creates this automatically.
   * Useful when editing existing records.
   */
  dbId: z.string().optional(),

  /**
   * User-entered identifier
   * Example: HMS-001 / AH64-RED-2 / TRK-ALPHA
   */
  platformId: z.string().min(1, "Platform ID is required"),

  // Core
  name: z.string().min(1, "Platform name is required"),
  type: z.enum(PLATFORM_TYPE_SCHEMA),

  // Position

  position: positionSchema,

  headingDeg: z.number().min(0).max(360).optional(),
  elevationM: z.number().optional(),
  enableGps: z.boolean().optional(),

  // Silos

  silos: z.array(siloSchema).min(1),

  // Classification
  model: z.string().optional(),
  manufacturer: z.string().optional(),
  serialNumber: z.string().optional(),
  callsign: z.string().optional(),
  nationality: z.string().optional(),
  faction: z.string().optional(),

  // Operational
  status: z.enum(PLATFORM_STATUS_SCHEMA),
  mobility: z.enum(MOBILITY_TYPE_SCHEMA),
  crewCapacity: z.number().int().nonnegative().optional(),
  currentCrew: z.number().int().nonnegative().optional(),

  // Performance
  maxSpeedKph: z.number().nonnegative().optional(),
  cruisingSpeedKph: z.number().nonnegative().optional(),
  rangeKm: z.number().nonnegative().optional(),
  enduranceHours: z.number().nonnegative().optional(),
  maxAltitudeM: z.number().nonnegative().optional(),

  // Physical
  lengthM: z.number().nonnegative().optional(),
  widthM: z.number().nonnegative().optional(),
  heightM: z.number().nonnegative().optional(),
  weightKg: z.number().nonnegative().optional(),

  // Fuel / Power
  fuelType: z.string().optional(),
  fuelCapacityLitres: z.number().nonnegative().optional(),
  powerPlant: z.string().optional(),

  // Defence
  armorRating: z.string().optional(),
  stealthCapable: z.boolean().optional(),
  shielded: z.boolean().optional(),

  // Sensors
  // radar: z.boolean().default(false),
  // sonar: z.boolean().default(false),
  // infrared: z.boolean().default(false),
  // gps: z.boolean().default(true),
  // communicationsSuite: z.string().optional(),

  // Mission
  homeBase: z.string().optional(),
  deploymentRegion: z.string().optional(),
  missionType: z.string().optional(),
  priorityLevel: z.number().int().min(1).max(5).optional(),

  // Future silo relationship
  // siloCount: z.number().int().nonnegative().default(0),
  // siloIds: z.array(z.string()).default([]),

  // Metadata
  notes: z.string().optional(),
  // tags: z.array(z.string()).default([]),

  // createdAt: z.coerce.date().default(() => new Date()),
  // updatedAt: z.coerce.date().default(() => new Date()),
});

/**
 * FORM SUPPORTING SINGLE OR MULTIPLE PLATFORMS
 */
export const platformsListSchema = z.object({
  platforms: z.array(platformSchema).min(1),
});

/**
 * TYPES
 */
export type Platform = z.infer<typeof platformSchema>;
export type Platforms = z.infer<typeof platformsListSchema>;
